// extracted by mini-css-extract-plugin
export default {"title":"ChangeAvatarModal_title__PrZHk","change_avatar_modal":"ChangeAvatarModal_change_avatar_modal__2nmnu","btnWrap":"ChangeAvatarModal_btnWrap__7zSCa"};